import { Box, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { preparePrice } from '../../helpers/lib';

const getStyleBySize = (size) => {
  switch (size) {
    case 'small':
      return {
        discountValue: { xs: 12, md: 18 },
        fullPrice: { xs: 12, md: 18 },
      };
    default:
      return {
        discountValue: { xs: 18, md: 22 },
        fullPrice: { xs: 18, md: 22 },
      };
  }
};
export default function DiscountLabel({
  discountValue,
  fullPrice,
  formattedDiscountDate,
  size = 'default',
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isLess410 = size !== 'small' && useMediaQuery('(max-width:410px)');
  if (!discountValue || !fullPrice) {
    return null;
  }
  const mobileStyles =
    isSm && isLess410
      ? {
          position: 'absolute',
          left: '100%',
          bottom: 0,
          transform: 'translate(-100%, -100%)',
        }
      : {};
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          gap: { xs: '11px', md: 1 },
        }}
      >
        <Typography
          variant="desktopH4"
          component={'p'}
          sx={{
            textDecoration: 'line-through',
            color: 'kit.text.secondary',
            fontSize: getStyleBySize(size).fullPrice,
            mt: isSm && isLess410 ? 1.5 : 0,
          }}
        >
          {`${preparePrice(fullPrice)} ₽`}
        </Typography>
        <Box
          sx={{
            lineHeight: 0,
            position: isSm && isLess410 ? 'absolute' : 'relative',

            width: 'max-content',
            display: 'flex',
            padding: { xs: '4px 10px 4px 8px', lg: '4px 12px 4px 10px' },
            alignItems: 'center',
            gap: { xs: '11px', lg: 2 },
            borderRadius: '12px',
            background: 'rgba(112, 243, 255, 0.22)',
            ...mobileStyles,
          }}
        >
          <Typography
            variant="desktopP1"
            sx={{
              color: '#835cf0',
              fontSize: getStyleBySize(size).discountValue,
              fontWeight: 'bold',
              textShadow: `1px 0px 0 #5F37CC, 1.25px -0.5px 0 #5F37CC, 1.5px -0.75px 0 #5F37CC, 1.75px -1px 0 #5F37CC`,
            }}
          >
            -{discountValue}%
          </Typography>
          {formattedDiscountDate && (
            <Typography variant="desktopP2" color={'kit.text.main'}>
              до {formattedDiscountDate}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
}
